import { useEffect, useState } from 'react';

import { MediaObjectType } from 'interfaces/mediaObject.types';
import { getMediaObjectURI, api } from 'services/api';
import { IChallengeImage } from 'interfaces';

type useImgSrcTypes = {
  fullUri: string;
  src: string;
  setSrc: (src: string) => void;
  error: string | null;
  setError: (err: string) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
};

/**
 * TODO: If necessary, retrieve the hook for use in the BO
 * Warning: The hook works only in build,
 * do not go into watch mode because of CORS problems
 */

export const useImgSrc = (
  partialUri:
    | string
    | number
    | MediaObjectType
    | IChallengeImage
    | undefined
    | null,
): useImgSrcTypes => {
  const fullUri = getMediaObjectURI(partialUri);
  const [src, setSrc] = useState<string>(fullUri);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (fullUri) {
      const getImage = async (uri: string) => {
        setLoading(true);
        setError(null);
        try {
          const { data } = await api.get(uri, { responseType: 'blob' });
          setSrc(URL.createObjectURL(data));
          setLoading(false);
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(
            `An error occurred in useImgSrc hook for ${partialUri}. ${err}. Use ${fullUri} as a source instead`,
          );
          setError(err);
          setLoading(false);
        }
      };
      getImage(fullUri);
    }
  }, [partialUri]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    fullUri,
    src,
    setSrc,
    error,
    setError,
    loading,
    setLoading,
  };
};
